import { lazy } from "react";
import { gradients } from "@/lib/constants";
import { ElementDetails } from "@/lib/types";
import { NotesProps } from "./types";

export const details = {
  name: "Notes",
  description: "Write down your thoughts and ideas.",
  tags: ["Productivity", "Organization"],
  category: "Widget",
  app: lazy(() => import("./App").then(m => ({ default: m.App }))),
  grid: {
    extraSmall: [2, 1],
    small: [2, 2],
    medium: [4, 2],
    large: [4, 4],
  },
  defaultProps: {
    color: gradients[1],
  },
  contextProvider: lazy(() => import("./ContextProvider")),
  integrationsUsed: ["InternalNote"],
  fields: [],
} as ElementDetails<NotesProps>;
